import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login'
import Register from '@/view/register'
import Home from '@/view/home'
import Curriculum from '@/view/curriculum'
import NewsBulletin from '@/view/newsBulletin'
import Teachers from '@/view/teachers'
import OpenClass from '@/view/openClass'
import LearningRecord from '@/view/learningRecord'
import UserInformation from '@/view/userInformation'
import TeacherDetail from '@/view/teacherDetail'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {path: '*', redirect: '/home'},
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/curriculum',
      name: 'Curriculum',
      component: Curriculum
    },
    {
      path: '/newsBulletin',
      name: 'NewsBulletin',
      component: NewsBulletin
    },
    {
      path: '/teachers',
      name: 'Teachers',
      component: Teachers
    },
    {
      path: '/openClass',
      name: 'OpenClass',
      component: OpenClass
    },
    {
      path: '/learningRecord',
      name: 'LearningRecord',
      component: LearningRecord
    },
    {
      path: '/userInformation',
      name: 'UserInformation',
      component: UserInformation
    },
    {
      path: '/teacherDetail',
      name: 'TeacherDetail',
      component: TeacherDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js